import { CycleUtils } from '@wix/package-picker-shared';
import { useCurrentModule } from '../components/ModuleProvider';
import { DEFAULT_PURCHASE_CYCLE, DEFAULT_SALE_PURCHASE_CYCLE } from '../utils/consts';
import { useCycleAvailability } from './useCycleAvailability';
import { useIsSeasonalSale } from './useIsSeasonalSale';
export const useSelectedCycle = () => {
  const module = useCurrentModule();
  const selectedCycle = module.SDK.PackagePickerStore.useSelectedCycle();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const {
    isCycleAvailable,
    lowestCycleAvailable
  } = useCycleAvailability(selectedProductId || undefined, selectedCycle || undefined);
  const isSeasonalSale = useIsSeasonalSale();
  if (!selectedCycle || !isCycleAvailable) {
    const presetCycle = isSeasonalSale ? DEFAULT_SALE_PURCHASE_CYCLE : DEFAULT_PURCHASE_CYCLE;
    const cycle = CycleUtils.maxCycle([lowestCycleAvailable, presetCycle]);
    module.SDK.PackagePickerStore.setSelectedCycleId(CycleUtils.convertCycleToCycleId(cycle || presetCycle));
    return cycle;
  }
  return selectedCycle;
};
//# sourceMappingURL=useSelectedCycle.js.map